module.exports = require("core-js/library/fn/object/get-own-property-descriptors");


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@babel_runtime-corejs2@7.20.1@@babel/runtime-corejs2/core-js/object/get-own-property-descriptors.js
// module id = AYka
// module chunks = 0